import React, { useEffect, useState } from "react";
import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  notification,
  Button,
  Row,
  Col,
  Card,
  Tag,
  Select,
  Spin,
  Table,
  Progress,
  DatePicker,
  Empty,
} from "antd";
import {
  ReloadOutlined,
  UserOutlined,
  ManOutlined,
  WomanOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import getVisitasTecnicas from "../../../services/visitas_tecnicas/visita_tecnica/getVisitasTecnicasService";
import ChartCard from "../../charts/ChartCard";
import ExportVisitasTecnicas from "../VisitaTecnica/VisitasTecnicasExcel";
import { useSelector } from "react-redux";

const { RangePicker } = DatePicker;

Chart.register(...registerables, ChartDataLabels);
const { Option } = Select;

const cardStyle = {
  textAlign: "center",
  borderRadius: 20,
  backgroundColor: "#ffffff",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  padding: 20,
  height: "90%",
};

const iconContainerStyle = {
  width: 80,
  height: 80,
  borderRadius: "50%",
  backgroundColor: "#F44336",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: "0 auto 10px",
};

const iconStyle = {
  fontSize: 40,
  color: "white",
};

const total = {
  fontSize: 30,
  color: "#333",
  margin: 0,
};

const InformeVisitasTecnicas = () => {
  const [data, setData] = useState(null);
  const [dataOriginal, setDataOriginal] = useState(null);
  const [dataFilter, setDataFilter] = useState(null);

  const [departamentoSeleccionado, setDepartamentoSeleccionado] =
    useState(null);
  const [municipioSeleccionado, setMunicipioSeleccionado] = useState(null);
  const [sectorSeleccionado, setSectorSeleccionado] = useState(null);
  const [numeroVisitaSeleccionado, setNumeroVisitaSeleccionado] =
    useState(null);
  const [rangoFechas, setRangoFechas] = useState(null);

  const [modalidadSecion, setModalidadSecion] = useState(null);

  const [visitasPorDepartamento, setVisitasPorDepartamento] = useState({});
  const [visitasPorMunicipio, setVisitasPorMunicipio] = useState({});
  const [visitasPorSector, setVisitasPorSector] = useState({});
  const [visitasPorGenero, setVisitasPorGenero] = useState({});
  const [visitasPorEnfoqueEtnico, setVisitasPorEnfoqueEtnico] = useState(null);
  const [visitasPorParticipante, setVisitasPorParticipante] = useState(null);
  const [visitasPorModalidad, setVisitasPorModalidad] = useState(null);
  const [visitasPorQuienResiveVisita, setVisitasPorQuienResiveVisita] =
    useState(null);
  const [visitasPorTemaCapacitacion, setVisitasPorTemaCapacitacion] =
    useState(null);
  const [
    visitasPornumeroPersonasParticipan,
    setVisitasPornumeroPersonasParticipan,
  ] = useState(null);
  const [visitasPornumeroHombreMujer, setVisitasPornumeroHombreMujer] =
    useState(null);
  const [visitasPorResponsableEntidad, setVisitasPorResponsableEntidad] =
    useState(null);

  const [listDepartamento, setListDepartamento] = useState(null);
  const [listMunicipio, setListMunicipio] = useState(null);
  const [listSector, setListSector] = useState(null);
  const [listMunicipiosPorDepartamento, setListMunicipiosPorDepartamento] =
    useState(null);
  const [listNumeroVisita, setlistNumeroVisita] = useState(null);
  const [totalParticipantes, setTotalParticipantes] = useState(null);

  const sectores = ["Pecuaria", "Agrícola", "Servicios"];

  const [indicadores, setIndicadores] = useState({
    totalVisitas: 0,
    totalParticipantes: 0,
    totalParticipantesVisitados: 0,
    duracionPromedioVisitas: 0,
    porcentajeAvance: 0,
  });

  const [dataResumenPorCapacitacion, setDataResumenPorCapacitacion] =
    useState(null);

  const usernameFromState = useSelector((state) => state.auth.user);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const [currentPage_2, setCurrentPage_2] = useState(1);
  const [pageSize_2, setPageSize_2] = useState(20);

  const fetchData = async () => {
    try {
      const response = await getVisitasTecnicas(usernameFromState.email);
      const { status, data, total_participantes } = response;

      if (status) {
        setTotalParticipantes(total_participantes);
        setData(data);
        setDataOriginal(data); // Guarda la data original
        setDataFilter(data);
        const departamentos = [...new Set(data.map((p) => p.departamento))];
        setListDepartamento(departamentos);
        // Agrupar municipios por departamento
        const municipiosPorDepartamento = data.reduce((acc, p) => {
          if (!acc[p.departamento]) {
            acc[p.departamento] = new Set();
          }
          acc[p.departamento].add(p.municipio);
          return acc;
        }, {});
        //Almacenamos la lista de municipios por departamento
        setListMunicipiosPorDepartamento(municipiosPorDepartamento);
        setListSector(sectores);

        const numero_visitas = [...new Set(data.map((p) => p.numero_visita))];
        setlistNumeroVisita(numero_visitas);

        calcularIndicadores(data);
      } else {
        notification.error({ message: response.message });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    }
  };

  useEffect(() => {
    if (!data) return;

    let visitasFiltradas = [...data];

    if (departamentoSeleccionado) {
      visitasFiltradas = visitasFiltradas.filter(
        (p) => p.departamento === departamentoSeleccionado
      );

      // Lista de municipios filtrados por el departamento seleccionado
      const municipios = departamentoSeleccionado
        ? [...listMunicipiosPorDepartamento[departamentoSeleccionado]]
        : [];
      setListMunicipio(municipios);
    }

    if (municipioSeleccionado) {
      visitasFiltradas = visitasFiltradas.filter(
        (p) => p.municipio === municipioSeleccionado
      );
    }

    if (sectorSeleccionado) {
      visitasFiltradas = visitasFiltradas.filter(
        (p) => p.linea_productiva === sectorSeleccionado
      );
    }
    if (numeroVisitaSeleccionado) {
      visitasFiltradas = visitasFiltradas.filter(
        (p) => p.numero_visita === numeroVisitaSeleccionado
      );
    }
    if (rangoFechas) {
      const [inicio, fin] = rangoFechas;
      visitasFiltradas = visitasFiltradas.filter((visita) => {
        const fechaVisita = new Date(visita.fecha_registro);
        return fechaVisita >= new Date(inicio) && fechaVisita <= new Date(fin);
      });
    }
    calcularIndicadores(visitasFiltradas);
  }, [
    departamentoSeleccionado,
    municipioSeleccionado,
    sectorSeleccionado,
    numeroVisitaSeleccionado,
    rangoFechas,
    data,
  ]);

  useEffect(() => {
    fetchData();
  }, []);

  const calcularIndicadores = (datos) => {
    //Total de visitas
    const totalVisitas = datos.length;
    // Total de participantes unicos visitados
    const totalParticipantesVisitados = new Set(
      datos.map((item) => item.id_participante)
    ).size;
    // Porcentaje de avance (ajustar según la lógica específica)
    const metaEsperada = totalParticipantes * 5; // 🔹 Ajusta este valor según tu negocio
    const porcentajeAvance = ((totalVisitas / metaEsperada) * 100).toFixed(2);

    //Promedio de duración por visita
    const duracionPromedioVisitas = calcularPromedioDuracion(datos);
    setIndicadores({
      totalVisitas,
      totalParticipantes,
      totalParticipantesVisitados,
      duracionPromedioVisitas,
      porcentajeAvance,
    });

    //Visitas por departamento
    const departamentosTemp = {};
    datos.forEach((p) => {
      departamentosTemp[p.departamento] =
        (departamentosTemp[p.departamento] || 0) + 1;
    });
    setVisitasPorDepartamento(departamentosTemp);

    //Visitas por municipio
    const municipiosTemp = {};
    datos.forEach((p) => {
      municipiosTemp[p.municipio] = (municipiosTemp[p.municipio] || 0) + 1;
    });
    setVisitasPorMunicipio(municipiosTemp);

    //Visitas por sector
    const sectorTemp = {};
    datos.forEach((p) => {
      sectorTemp[p.linea_productiva] =
        (sectorTemp[p.linea_productiva] || 0) + 1;
    });
    setVisitasPorSector(sectorTemp);

    //visitas por modalidad de secion
    const modalidadSecionTemp = {};
    datos.forEach((p) => {
      modalidadSecionTemp[p.modalidad_sesion_capacitacion] =
        (modalidadSecionTemp[p.modalidad_sesion_capacitacion] || 0) + 1;
    });
    setModalidadSecion(modalidadSecionTemp);

    //Visitas por genero
    const resultGeneroTemp = obtenerDatosNumeroVisitaPorSexo(datos);
    setVisitasPorGenero(resultGeneroTemp);

    //Visitas por enfoque etnico
    const enfoqueEtnicoTemp = {};
    datos.forEach((p) => {
      enfoqueEtnicoTemp[p.enfoque_etnico] =
        (enfoqueEtnicoTemp[p.enfoque_etnico] || 0) + 1;
    });
    setVisitasPorEnfoqueEtnico(enfoqueEtnicoTemp);

    let participantesConVisitas = {};

    //Total de Visitas por participante
    // Agrupar información y contar visitas

    datos.forEach((item) => {
      const { id_participante } = item;

      if (!participantesConVisitas[id_participante]) {
        participantesConVisitas[id_participante] = {
          codigoSIRR: item.codigoSIRR,
          numeroIdentificacion: item.numeroIdentificacion,
          nombre_if: item.nombre_if,
          sexo_sir: item.sexo_sir,
          linea_productiva: item.linea_productiva,
          nombreProyecto: item.nombreProyecto,
          total_visitas: 0,
        };
      }

      // Incrementar visitas
      participantesConVisitas[id_participante].total_visitas++;
    });
    // Convertir a array
    const participantesArray = Object.entries(participantesConVisitas).map(
      ([id, data]) => ({
        id_participante: id,
        ...data, // Agregar el resto de la información
      })
    );

    setVisitasPorParticipante(participantesArray);

    //Visitas por modalidad
    const modalidadTemp = {};
    datos.forEach((p) => {
      modalidadTemp[p.modalidad] = (modalidadTemp[p.modalidad] || 0) + 1;
    });
    setVisitasPorModalidad(modalidadTemp);

    //Visitas por quien recibe la visita
    const quienRecibeVisitaTemp = {};
    datos.forEach((p) => {
      quienRecibeVisitaTemp[p.quienRecibeVisita] =
        (quienRecibeVisitaTemp[p.quienRecibeVisita] || 0) + 1;
    });
    setVisitasPorQuienResiveVisita(quienRecibeVisitaTemp);

    // 📌 Contar capacitaciones por tema en todo el array
    const contarTemas = datos.reduce((acc, visita) => {
      // ✅ Si lista_capacitaciones es null, undefined o no es un array, se ignora
      if (!Array.isArray(visita.lista_capacitaciones)) return acc;

      visita.lista_capacitaciones.forEach((capacitacion) => {
        acc[capacitacion.tema] = (acc[capacitacion.tema] || 0) + 1;
      });

      return acc;
    }, {});

    setVisitasPorTemaCapacitacion(contarTemas);

    //Visitas por Numero de personas que participan en la visita
    const numeroPersonasParticipanTemp = {};
    datos.forEach((p) => {
      numeroPersonasParticipanTemp[p.numeroPersonasParticipan] =
        (numeroPersonasParticipanTemp[p.numeroPersonasParticipan] || 0) + 1;
    });
    setVisitasPornumeroPersonasParticipan(numeroPersonasParticipanTemp);

    //Visitas por Numero de Hombres y mujeres que participan en la visita
    // 📌 Reducir el array para sumar los valores
    const numeroHombresMujeresnTemp = datos.reduce(
      (acc, visita) => {
        acc.numeroHombres += Number(visita.numeroHombres) || 0;
        acc.numeroMujeres += Number(visita.numeroMujeres) || 0;
        return acc;
      },
      { numeroHombres: 0, numeroMujeres: 0 } // Estado inicial
    );

    setVisitasPornumeroHombreMujer(numeroHombresMujeresnTemp);

    //Visitas por responsable entidad
    const responsableEntidadTemp = {};
    datos.forEach((p) => {
      responsableEntidadTemp[p.responsable] =
        (responsableEntidadTemp[p.responsable] || 0) + 1;
    });
    setVisitasPorResponsableEntidad(responsableEntidadTemp);

    // Obtener data para tabla de detalle por capacitación
    const allCapacitaciones = datos.flatMap((item) =>
      (item.lista_capacitaciones || []).map((cap) => ({
        id: item.id, // id de la visita
        ...cap,
        departamento: item.departamento,
        municipio: item.municipio,
        numeroHombres: Number(item.numeroHombres) || 0,
        numeroMujeres: Number(item.numeroMujeres) || 0,
      }))
    );

    // Agrupar por tema + departamento + municipio
    const grouped = allCapacitaciones.reduce((acc, item) => {
      const key = `${item.tema}-${item.departamento}-${item.municipio}`; // clave única por tema y ubicación

      if (!acc[key]) {
        acc[key] = {
          tema: item.tema,
          departamento: item.departamento,
          municipio: item.municipio,
          numeroHombres: 0,
          numeroMujeres: 0,
          total: 0,
        };
      }

      acc[key].numeroHombres += item.numeroHombres;
      acc[key].numeroMujeres += item.numeroMujeres;
      acc[key].total = acc[key].numeroHombres + acc[key].numeroMujeres;

      return acc;
    }, {});

    const tableDataResumenCapacitacion = Object.values(grouped);
    setDataResumenPorCapacitacion(tableDataResumenCapacitacion);

    //Visitas por tema de capacitación
    setDataFilter(datos);
  };

  const obtenerDatosNumeroVisitaPorSexo = (datos) => {
    return datos.reduce((acc, visita) => {
      const numVisita = visita.numero_visita;
      const sexo = visita.sexo_sir || "No especificado"; // Si no tiene sexo, lo agrupa en "No especificado"

      if (!acc[numVisita]) {
        acc[numVisita] = {};
      }

      if (!acc[numVisita][sexo]) {
        acc[numVisita][sexo] = 0;
      }

      acc[numVisita][sexo] += 1; // Contar cuántas personas hay por género en cada visita

      return acc;
    }, {});
  };

  const calcularPromedioDuracion = (visitas) => {
    if (!Array.isArray(visitas) || visitas.length === 0) {
      return "0h 0min"; // Evita errores si el array está vacío
    }

    const convertirAMinutos = (hora) => {
      if (!hora) return 0; // Manejo de valores undefined/null

      const [time, meridian] = hora.split(" ");
      if (!time || !meridian) return 0; // Evita errores si el formato es incorrecto

      const [horas, minutos] = time.split(":").map(Number);
      let totalMinutos = horas * 60 + minutos;

      // Convertir a formato 24 horas
      if (meridian.toLowerCase() === "pm" && horas !== 12)
        totalMinutos += 12 * 60;
      if (meridian.toLowerCase() === "am" && horas === 12)
        totalMinutos -= 12 * 60;

      return totalMinutos;
    };

    // Calcular la duración total
    let totalMinutos = 0;
    let visitasValidas = 0;

    visitas.forEach((visita) => {
      if (visita.horaInicio && visita.horaFin) {
        const inicioMinutos = convertirAMinutos(visita.horaInicio);
        const finMinutos = convertirAMinutos(visita.horaFin);

        if (finMinutos > inicioMinutos) {
          // Asegura que la hora de fin sea mayor
          totalMinutos += finMinutos - inicioMinutos;
          visitasValidas++;
        }
      }
    });

    // Evita división por cero
    if (visitasValidas === 0) return "0h 0min";

    // Calcular el promedio en minutos
    const promedioMinutos = totalMinutos / visitasValidas;

    // Convertir minutos a horas y minutos
    const horas = Math.floor(promedioMinutos / 60);
    const minutos = Math.round(promedioMinutos % 60);

    return `${horas}h ${minutos}min`;
  };

  const columns = [
    {
      title: "Codigo SIRR",
      dataIndex: "codigoSIRR",
      key: "codigoSIRR",
      width: 150,
    },
    {
      title: "Número identificación",
      dataIndex: "numeroIdentificacion",
      key: "numeroIdentificacion",
      width: 150,
    },

    {
      title: "Nombre titular",
      dataIndex: "nombre_if",
      key: "nombre_if",
      width: 150,
    },
    {
      title: "Género",
      dataIndex: "sexo_sir",
      key: "sexo_sir",
      width: 150,
    },
    {
      title: "Linea productiva",
      dataIndex: "linea_productiva",
      key: "linea_productiva",
      width: 150,
    },
    {
      title: "Nombre del proyecto",
      dataIndex: "nombreProyecto",
      key: "nombreProyecto",
      width: 150,
    },
    {
      title: "Total de Visitas",
      dataIndex: "total_visitas",
      key: "total_visitas",
      align: "center", // Centrar texto en la columna
      width: 150,
    },

    {
      title: "Porcentaje de avance",
      dataIndex: "porcentaje",
      key: "porcentaje",
      width: 150,

      render: (_, record) => {
        const totalFormularios = 5;
        const porcentaje = (record.total_visitas / totalFormularios) * 100;

        return (
          <Progress
            percent={porcentaje.toFixed(0)}
            status={porcentaje === 100 ? "success" : "active"}
            strokeColor={porcentaje === 100 ? "#52c41a" : "#1890ff"}
          />
        );
      },
    },
  ];

  const columnsResumenCapacitacion = [
    {
      title: "Tematica",
      dataIndex: "tema",
      key: "tema",
      width: 150,
    },
    {
      title: "Departamento",
      dataIndex: "departamento",
      key: "departamento",
      width: 150,
    },

    {
      title: "Municipio",
      dataIndex: "municipio",
      key: "municipio",
      width: 150,
    },
    {
      title: "Hombres",
      dataIndex: "numeroHombres",
      key: "numeroHombres",
      width: 150,
    },
    {
      title: "Mujeres",
      dataIndex: "numeroMujeres",
      key: "numeroMujeres",
      width: 150,
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      width: 150,
    },
  ];

  if (!data) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
        <p style={{ marginTop: 16, fontSize: 16, color: "#888" }}>
          Cargando datos...
        </p>
      </div>
    );
  }

  return (
    <>
      {dataOriginal.length === 0 ? (
        <Empty
          description="No hay Visitas disponibles"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      ) : (
        <Card style={{ padding: 20 }}>
          <Tag
            color="#D0E0F2"
            style={{
              color: "#145BAD",
              fontSize: "25px",
              fontWeight: "bold",
              padding: "8px 15px",
              borderRadius: "8px",
              textAlign: "center",
              display: "block",
              marginBottom: "15px",
            }}
          >
            INFORME VISITAS TÉCNICAS
          </Tag>
          {/* Filtros */}
          <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
            {/*filtro departamento */}
            <Col xs={24} sm={8} md={4}>
              <Select
                placeholder="Seleccione un departamento"
                style={{ width: "100%" }}
                value={departamentoSeleccionado}
                onChange={(value) => {
                  setDepartamentoSeleccionado(value);
                  setMunicipioSeleccionado(null);
                }}
                disabled={!listDepartamento || listDepartamento.length === 0} // Asegura que listMunicipio es válido
                showSearch
                optionFilterProp="children" // busca dentro del texto de las opciones
              >
                {listDepartamento.map((dep) => (
                  <Option key={dep} value={dep}>
                    {dep}
                  </Option>
                ))}
              </Select>
            </Col>

            {/*filtro Municipio */}
            <Col xs={24} sm={8} md={4}>
              <Select
                placeholder="Selecciona un municipio"
                style={{ width: "100%" }}
                value={municipioSeleccionado || undefined} // Evita null
                onChange={(value) => setMunicipioSeleccionado(value)}
                disabled={!listMunicipio || listMunicipio.length === 0} // Asegura que listMunicipio es válido
                showSearch
                optionFilterProp="children" // busca dentro del texto de las opciones
              >
                {listMunicipio?.map((mun) => (
                  <Option key={mun} value={mun}>
                    {mun}
                  </Option>
                ))}
              </Select>
            </Col>

            {/*filtro por sector */}
            <Col xs={24} sm={6} md={4}>
              <Select
                placeholder="Selecciona un sector"
                style={{ width: "100%" }}
                value={sectorSeleccionado}
                onChange={(value) => {
                  setSectorSeleccionado(value);
                }}
                disabled={!listSector || listSector.length === 0}
                showSearch
                optionFilterProp="children" // busca dentro del texto de las opciones
              >
                {listSector.map((sec) => (
                  <Option key={sec} value={sec}>
                    {sec}
                  </Option>
                ))}
              </Select>
            </Col>

            {/*filtro por numero de visita */}
            <Col xs={24} sm={6} md={4}>
              <Select
                placeholder="Selecciona número de visita"
                style={{ width: "100%" }}
                value={numeroVisitaSeleccionado}
                onChange={(value) => {
                  setNumeroVisitaSeleccionado(value);
                }}
                disabled={!listNumeroVisita || listNumeroVisita.length === 0}
                showSearch
                optionFilterProp="children" // busca dentro del texto de las opciones
              >
                {listNumeroVisita.map((sec) => (
                  <Option key={sec} value={sec}>
                    Visita {sec}
                  </Option>
                ))}
              </Select>
            </Col>

            {/*filtro por rango de fecha de registro */}
            <Col xs={24} sm={8} md={5}>
              <RangePicker
                style={{ width: "100%" }}
                value={rangoFechas}
                onChange={(value) => {
                  setRangoFechas(value);
                }}
              />
            </Col>

            {/*Restablecer información */}
            <Col xs={24} sm={12} md={1}>
              <Button
                type="primary"
                icon={<ReloadOutlined />}
                onClick={() => {
                  setDepartamentoSeleccionado(null);
                  setMunicipioSeleccionado(null);
                  setSectorSeleccionado(null);
                  setNumeroVisitaSeleccionado(null);
                  setRangoFechas(null);
                }}
              ></Button>
            </Col>

            {/* Botón Exportar data */}
            <Col xs={12} sm={6} md={2} lg={2}>
              <ExportVisitasTecnicas
                dataCompleta={dataFilter}
              ></ExportVisitasTecnicas>
            </Col>
          </Row>

          {/*TOTALIZADORES EN CARDS */}
          <Row gutter={[24, 24]} style={{ margin: "20px 40px" }}>
            <Col xs={24} sm={12} md={5}>
              <Card bordered={false} style={cardStyle}>
                <div
                  style={{ ...iconContainerStyle, backgroundColor: "#0051AE" }}
                >
                  <UserOutlined style={iconStyle} />
                </div>
                <h3
                  style={{
                    fontSize: 15,
                    fontWeight: "bold",
                    color: "#0051AE",
                    marginBottom: 5,
                  }}
                >
                  Total participantes
                </h3>
                <h2 style={total}>{indicadores.totalParticipantes}</h2>
              </Card>
            </Col>

            <Col xs={24} sm={12} md={5}>
              <Card bordered={false} style={cardStyle}>
                <div
                  style={{ ...iconContainerStyle, backgroundColor: "#468CDE" }}
                >
                  <ManOutlined style={iconStyle} />
                </div>
                <h3
                  style={{
                    fontSize: 15,
                    fontWeight: "bold",
                    color: "#468CDE",
                    marginBottom: 5,
                  }}
                >
                  Total visitas
                </h3>
                <h2 style={total}>{indicadores.totalVisitas}</h2>
              </Card>
            </Col>

            <Col xs={24} sm={12} md={5}>
              <Card bordered={false} style={cardStyle}>
                <div
                  style={{ ...iconContainerStyle, backgroundColor: "#0051AE" }}
                >
                  <WomanOutlined style={iconStyle} />
                </div>
                <h3
                  style={{
                    fontSize: 15,
                    fontWeight: "bold",
                    color: "#0051AE",
                    marginBottom: 5,
                  }}
                >
                  Total participantes visitados
                </h3>
                <h2 style={total}>{indicadores.totalParticipantesVisitados}</h2>
              </Card>
            </Col>

            <Col xs={24} sm={12} md={5}>
              <Card bordered={false} style={cardStyle}>
                <div
                  style={{ ...iconContainerStyle, backgroundColor: "#C2BCBC" }}
                >
                  <ClockCircleOutlined style={iconStyle} />
                </div>
                <h3
                  style={{
                    fontSize: 15,
                    fontWeight: "bold",
                    color: "#C2BCBC",
                    marginBottom: 5,
                  }}
                >
                  Promedio de tiempo por visita
                </h3>
                <h2 style={total}>{indicadores.duracionPromedioVisitas}</h2>
              </Card>
            </Col>

            <Col xs={24} sm={12} md={4}>
              <Card bordered={false} style={cardStyle}>
                {(() => {
                  const porcentaje = indicadores.porcentajeAvance;
                  let color = "#52C41A"; // Verde por defecto
                  if (porcentaje >= 0 && porcentaje < 30)
                    color = "#FF4D4F"; // Rojo
                  else if (porcentaje >= 30 && porcentaje < 60)
                    color = "#FFCE00"; // Amarillo
                  else if (porcentaje >= 60 && porcentaje < 100)
                    color = "#FA8C16"; // Naranja

                  return (
                    <>
                      <div
                        style={{
                          ...iconContainerStyle,
                          backgroundColor: color,
                        }}
                      >
                        <CheckCircleOutlined style={iconStyle} />
                      </div>
                      <h3
                        style={{
                          fontSize: 15,
                          fontWeight: "bold",
                          color,
                          marginBottom: 5,
                        }}
                      >
                        Porcentaje de avance
                      </h3>
                      <h2 style={total}>{porcentaje} %</h2>
                    </>
                  );
                })()}
              </Card>
            </Col>
          </Row>

          <Card style={{ padding: 20 }}>
            <Tag
              color="#D0E0F2"
              style={{
                color: "#145BAD",
                fontSize: "20px",
                fontWeight: "bold",
                padding: "8px 15px",
                borderRadius: "8px",
                textAlign: "left",
                display: "block",
                marginBottom: "15px",
              }}
            >
              INFORMACIÓN GENERAL
            </Tag>

            <Row gutter={[16]} style={{ marginTop: 20 }}>
              {/* Gráfico 1: Visitas por Departamento o Municipio */}
              <Col xs={24} sm={24} md={12} lg={12}>
                <ChartCard
                  title={
                    departamentoSeleccionado
                      ? `Número de visitas por municipio en ${departamentoSeleccionado}`
                      : "Número de visitas por departamento"
                  }
                  data={{
                    labels: departamentoSeleccionado
                      ? Object.keys(visitasPorMunicipio)
                      : Object.keys(visitasPorDepartamento),
                    datasets: [
                      {
                        label: municipioSeleccionado
                          ? "Municipio"
                          : departamentoSeleccionado
                          ? "Departamento"
                          : "Departamento",
                        data: departamentoSeleccionado
                          ? Object.values(visitasPorMunicipio)
                          : Object.values(visitasPorDepartamento),
                        backgroundColor: "#145BAD",
                        borderRadius: 5,
                        barThickness: 40,
                      },
                    ],
                  }}
                  backgroundColor="#145BAD"
                />
              </Col>

              {/*Gráfico 3 - Número de visitas por Género*/}
              <Col xs={24} sm={24} md={12} lg={12}>
                <ChartCard
                  title="Número de visitas por género"
                  data={{
                    labels: Object.keys(visitasPorGenero).map(
                      (visita) => `Visita ${visita}`
                    ),
                    datasets: Object.keys(
                      Object.values(visitasPorGenero).reduce(
                        (acc, curr) => ({ ...acc, ...curr }),
                        {}
                      )
                    ).map((sexo) => ({
                      label: sexo,
                      data: Object.keys(visitasPorGenero).map(
                        (visita) => visitasPorGenero[visita][sexo] || 0
                      ),
                      backgroundColor:
                        sexo === "Hombre"
                          ? "rgba(54, 162, 235, 0.6)"
                          : sexo === "Mujer"
                          ? "#145BAD"
                          : "rgba(153, 102, 255, 0.6)",
                    })),
                  }}
                />
              </Col>
              {/* Gráfico 2: Visitas por Sector */}
              <Col xs={24} sm={24} md={12} lg={12}>
                <ChartCard
                  title="Número de visitas  por sector"
                  data={{
                    labels: Object.keys(visitasPorSector),
                    datasets: [
                      {
                        label: "Sector",
                        data: Object.values(visitasPorSector),
                        backgroundColor: "#5B93D3",
                        borderRadius: 5,
                        barThickness: 40,
                      },
                    ],
                  }}
                  backgroundColor="#5B93D3"
                />
              </Col>

              {/* Gráfico 2: Visitas por reponsable entidad */}
              <Col xs={24} sm={24} md={12} lg={12}>
                <ChartCard
                  title="Número de visitas por entidad"
                  data={{
                    labels: Object.keys(visitasPorResponsableEntidad),
                    datasets: [
                      {
                        label: "Entidad",
                        data: Object.values(visitasPorResponsableEntidad),
                        backgroundColor: "#5B93D3",
                        borderRadius: 5,
                        barThickness: 40,
                      },
                    ],
                  }}
                  backgroundColor="#5B93D3"
                />
              </Col>

              {/*Tabla de resumen datos generales */}
              <Col xs={24} sm={24} md={24} lg={24}>
                <div style={{ overflowX: "auto", marginTop: 30 }}>
                  <Table
                    dataSource={visitasPorParticipante}
                    columns={columns}
                    rowKey="id_participante"
                    bordered
                    scroll={{ y: 500, x: "max-content" }}
                    pagination={{
                      current: currentPage, // página actual
                      pageSize: pageSize, // filas por página
                      total: visitasPorParticipante.length, // total de registros
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "20", "50", "100"],
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} de ${total} registros`,
                      onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                      },
                    }}
                  />
                </div>
              </Col>
            </Row>
          </Card>
          <Card style={{ padding: 20 }}>
            <Tag
              color="#D0E0F2"
              style={{
                color: "#145BAD",
                fontSize: "20px",
                fontWeight: "bold",
                padding: "8px 15px",
                borderRadius: "8px",
                textAlign: "left",
                display: "block",
                marginBottom: "15px",
              }}
            >
              INFORMACIÓN INTERNA
            </Tag>

            <Row gutter={[16]} style={{ marginTop: 20 }}>
              {/*Gráfico 5 - Visitas Técnicas por Modalidad de sesión*/}
              <Col xs={24} sm={24} md={12} lg={12}>
                <ChartCard
                  title="Número de visitas por modalidad de sesión de capacitación"
                  chartType="bar"
                  data={{
                    labels: Object.keys(modalidadSecion),
                    datasets: [
                      {
                        label: "Modalidad de sesión",
                        data: Object.values(modalidadSecion),
                        backgroundColor: "#5B93D3",
                        borderRadius: 5, // Bordes redondeados en las barras
                        barThickness: 40, // Define el grosor de las barras
                      },
                    ],
                  }}
                />
              </Col>

              {/*Gráfico 6 -  Visitas Técnicas Modalidad*/}
              <Col xs={24} sm={24} md={12} lg={12}>
                <ChartCard
                  title="% de visitas por modalidad"
                  chartType="pie"
                  showAsPercentage={true}
                  data={{
                    labels: Object.keys(visitasPorModalidad),
                    datasets: [
                      {
                        label: "Modalidad de sesión",
                        data: Object.values(visitasPorModalidad),
                        backgroundColor: [
                          "#145BAD",
                          "rgba(54, 162, 235, 0.6)",
                          "rgba(75, 192, 192, 0.6)",
                          "#D4D2D2",
                          "rgba(255, 99, 132, 0.6)",
                          "rgba(255, 159, 64, 0.6)",
                        ],
                        borderRadius: 5, // Bordes redondeados en las barras
                        barThickness: 40, // Define el grosor de las barras
                      },
                    ],
                  }}
                />
              </Col>

              {/*Gráfico 7 - Visitas Técnicas - Quien recibe la modalidad*/}
              <Col xs={24} sm={24} md={12} lg={12}>
                <ChartCard
                  title="Quien recibe la visita"
                  chartType="bar"
                  data={{
                    labels: Object.keys(visitasPorQuienResiveVisita),
                    datasets: [
                      {
                        label: "Quien recibe la visita",
                        data: Object.values(visitasPorQuienResiveVisita),
                        backgroundColor: "#145BAD",
                        borderRadius: 5, // Bordes redondeados en las barras
                        barThickness: 40, // Define el grosor de las barras
                      },
                    ],
                  }}
                />
              </Col>

              {/*Gráfico 8 - */}
              <Col xs={24} sm={24} md={12} lg={12}>
                <ChartCard
                  title="Número de visitas por tema de capacitación"
                  chartType="bar"
                  data={{
                    labels: Object.keys(visitasPorTemaCapacitacion),
                    datasets: [
                      {
                        label: "Tema de capacitación",
                        data: Object.values(visitasPorTemaCapacitacion),
                        backgroundColor: "#5B93D3",
                        borderRadius: 5, // Bordes redondeados en las barras
                        barThickness: 40, // Define el grosor de las barras
                      },
                    ],
                  }}
                />
              </Col>

              {/*Gráfico 9 - */}
              <Col xs={24} sm={24} md={12} lg={12}>
                <ChartCard
                  title="Número de personas que participan en la visita"
                  chartType="bar"
                  data={{
                    labels: Object.keys(visitasPornumeroPersonasParticipan),
                    datasets: [
                      {
                        label: "Número de personas",
                        data: Object.values(visitasPornumeroPersonasParticipan),
                        backgroundColor: [
                          "#145BAD",
                          "rgba(54, 162, 235, 0.6)",
                          "rgba(75, 192, 192, 0.6)",
                          "#D4D2D2",
                          "rgba(255, 99, 132, 0.6)",
                          "rgba(255, 159, 64, 0.6)",
                        ],
                        borderRadius: 5, // Bordes redondeados en las barras
                        barThickness: 40, // Define el grosor de las barras
                      },
                    ],
                  }}
                />
              </Col>

              {/*Gráfico 10 - */}
              <Col xs={24} sm={24} md={12} lg={12}>
                <ChartCard
                  title="Personas que participan en la visita por género"
                  chartType="bar"
                  data={{
                    labels: ["Hombres", "Mujeres"],
                    datasets: [
                      {
                        label: "Número de personas",
                        data: [
                          visitasPornumeroHombreMujer.numeroHombres,
                          visitasPornumeroHombreMujer.numeroMujeres,
                        ],
                        backgroundColor: [
                          "#145BAD",
                          "rgba(54, 162, 235, 0.6)",
                          "rgba(75, 192, 192, 0.6)",
                          "#D4D2D2",
                          "rgba(255, 99, 132, 0.6)",
                          "rgba(255, 159, 64, 0.6)",
                        ],
                        borderRadius: 5, // Bordes redondeados en las barras
                        barThickness: 40, // Define el grosor de las barras
                      },
                    ],
                  }}
                />
              </Col>

              {/*Tabla de resumen datos capacitaciones */}
              <Col xs={24} sm={24} md={24} lg={24}>
                <div style={{ overflowX: "auto", marginTop: 30 }}>
                  <Table
                    dataSource={dataResumenPorCapacitacion || []}
                    columns={columnsResumenCapacitacion}
                    rowKey={(record) => `${record.id}-${record.tema}`}
                    scroll={{ y: 500, x: "max-content" }}
                    pagination={{
                      current: currentPage_2, // página actual
                      pageSize: pageSize_2, // filas por página
                      total: dataResumenPorCapacitacion.length, // total de registros
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "20", "50", "100"],
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} de ${total} registros`,
                      onChange: (page, size) => {
                        setCurrentPage_2(page);
                        setPageSize_2(size);
                      },
                    }}
                    bordered
                  />
                </div>
              </Col>
            </Row>
          </Card>
        </Card>
      )}
    </>
  );
};

export default InformeVisitasTecnicas;
